import { render } from "./form-sign-up.vue?vue&type=template&id=45ffd522"
import script from "./form-sign-up.vue?vue&type=script&lang=js"
export * from "./form-sign-up.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__